export class RegionNames {
    public static readonly main = 'main';
}
